import { SPORT_PRIORITIES } from './tipico_menu';

// Country flags (German names → emoji)
export const COUNTRY_FLAGS: Record<string, string> = {
  'Spanien': '🇪🇸',
  'England': '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  'Deutschland': '🇩🇪',
  'Italien': '🇮🇹',
  'Frankreich': '🇫🇷',
  'Portugal': '🇵🇹',
  'Niederlande': '🇳🇱',
  'Belgien': '🇧🇪',
  'Andorra': '🇦🇩',
  'Argentinien': '🇦🇷',
  'Armenien': '🇦🇲',
  'Aserbaidschan': '🇦🇿',
  'Äthiopien': '🇪🇹',
  'Australien': '🇦🇺',
  'Belarus': '🇧🇾',
  'Bolivien': '🇧🇴',
  'Bosnien&Herzegowina': '🇧🇦',
  'Brasilien': '🇧🇷',
  'Bulgarien': '🇧🇬',
  'Champions League': '🏆',
  'Chile': '🇨🇱',
  'China': '🇨🇳',
  'Copa Libertadores': '🏆',
  'Copa Sudamericana': '🏆',
  'Costa Rica': '🇨🇷',
  'Dänemark': '🇩🇰',
  'Dominikanische Republik': '🇩🇴',
  'Ecuador': '🇪🇨',
  'El Salvador': '🇸🇻',
  'Estland': '🇪🇪',
  'Europa Conference League': '🏆',
  'Europa League': '🏆',
  'Färöer': '🇫🇴',
  'Finnland': '🇫🇮',
  'Georgien': '🇬🇪',
  'Griechenland': '🇬🇷',
  'Guatemala': '🇬🇹',
  'Honduras': '🇭🇳',
  'Hong Kong': '🇭🇰',
  'Indien': '🇮🇳',
  'Indonesien': '🇮🇩',
  'International': '🌍',
  'International Clubs': '🌍',
  'Internationale Klubturniere': '🏆',
  'Irak': '🇮🇶',
  'Irland': '🇮🇪',
  'Island': '🇮🇸',
  'Israel': '🇮🇱',
  'Japan': '🇯🇵',
  'Kamerun': '🇨🇲',
  'Kanada': '🇨🇦',
  'Kasachstan': '🇰🇿',
  'Kolumbien': '🇨🇴',
  'Kroatien': '🇭🇷',
  'Litauen': '🇱🇹',
  'Luxemburg': '🇱🇺',
  'Malaysia': '🇲🇾',
  'Marokko': '🇲🇦',
  'Mexiko': '🇲🇽',
  'Montenegro': '🇲🇪',
  'Neuseeland': '🇳🇿',
  'Nicaragua': '🇳🇮',
  'Norwegen': '🇳🇴',
  'Österreich': '🇦🇹',
  'Panama': '🇵🇦',
  'Paraguay': '🇵🇾',
  'Peru': '🇵🇪',
  'Polen': '🇵🇱',
  'Rumänien': '🇷🇴',
  'Saudi Arabien': '🇸🇦',
  'Schottland': '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  'Schweden': '🇸🇪',
  'Schweiz': '🇨🇭',
  'Senegal': '🇸🇳',
  'Serbien': '🇷🇸',
  'Simbabwe': '🇿🇼',
  'Singapur': '🇸🇬',
  'Slowakei': '🇸🇰',
  'Slowenien': '🇸🇮',
  'Südafrika': '🇿🇦',
  'Südkorea': '🇰🇷',
  'Thailand': '🇹🇭',
  'Tschechien': '🇨🇿',
  'Tunesien': '🇹🇳',
  'Türkei': '🇹🇷',
  'UEFA Nations League': '🏆',
  'Ungarn': '🇭🇺',
  'Uruguay': '🇺🇾',
  'USA': '🇺🇸',
  'V.A. Emirate': '🇦🇪',
  'Venezuela': '🇻🇪',
  'Vietnam': '🇻🇳',
  'WM 2026': '🏆',
  'WM 2026, Herren': '🏆',
  'Zypern': '🇨🇾',
};

export const EN_TO_DE_COUNTRIES: Record<string, string> = {
  'Spain': 'Spanien',
  'England': 'England',
  'Germany': 'Deutschland',
  'Italy': 'Italien',
  'France': 'Frankreich',
  'Portugal': 'Portugal',
  'Netherlands': 'Niederlande',
  'Belgium': 'Belgien',
  'Andorra': 'Andorra',
  'Argentina': 'Argentinien',
  'Armenia': 'Armenien',
  'Azerbaijan': 'Aserbaidschan',
  'Ethiopia': 'Äthiopien',
  'Australia': 'Australien',
  'Belarus': 'Belarus',
  'Bolivia': 'Bolivien',
  'Bosnia & Herzegovina': 'Bosnien&Herzegowina',
  'Bosnia and Herzegovina': 'Bosnien&Herzegowina',
  'Brazil': 'Brasilien',
  'Bulgaria': 'Bulgarien',
  'Chile': 'Chile',
  'China': 'China',
  'Costa Rica': 'Costa Rica',
  'Denmark': 'Dänemark',
  'Dominican Republic': 'Dominikanische Republik',
  'Ecuador': 'Ecuador',
  'El Salvador': 'El Salvador',
  'Estonia': 'Estland',
  'Faroe Islands': 'Färöer',
  'Finland': 'Finnland',
  'Georgia': 'Georgien',
  'Greece': 'Griechenland',
  'Guatemala': 'Guatemala',
  'Honduras': 'Honduras',
  'Hong Kong': 'Hong Kong',
  'India': 'Indien',
  'Indonesia': 'Indonesien',
  'Iraq': 'Irak',
  'Ireland': 'Irland',
  'Iceland': 'Island',
  'Israel': 'Israel',
  'Japan': 'Japan',
  'Cameroon': 'Kamerun',
  'Canada': 'Kanada',
  'Kazakhstan': 'Kasachstan',
  'Colombia': 'Kolumbien',
  'Croatia': 'Kroatien',
  'Lithuania': 'Litauen',
  'Luxembourg': 'Luxemburg',
  'Malaysia': 'Malaysia',
  'Morocco': 'Marokko',
  'Mexico': 'Mexiko',
  'Montenegro': 'Montenegro',
  'New Zealand': 'Neuseeland',
  'Nicaragua': 'Nicaragua',
  'Norway': 'Norwegen',
  'Austria': 'Österreich',
  'Panama': 'Panama',
  'Paraguay': 'Paraguay',
  'Peru': 'Peru',
  'Poland': 'Polen',
  'Romania': 'Rumänien',
  'Saudi Arabia': 'Saudi Arabien',
  'Scotland': 'Schottland',
  'Sweden': 'Schweden',
  'Switzerland': 'Schweiz',
  'Senegal': 'Senegal',
  'Serbia': 'Serbien',
  'Zimbabwe': 'Simbabwe',
  'Singapore': 'Singapur',
  'Slovakia': 'Slowakei',
  'Slovenia': 'Slowenien',
  'South Africa': 'Südafrika',
  'South Korea': 'Südkorea',
  'Thailand': 'Thailand',
  'Czech Republic': 'Tschechien',
  'Tunisia': 'Tunesien',
  'Turkey': 'Türkei',
  'Hungary': 'Ungarn',
  'Uruguay': 'Uruguay',
  'USA': 'USA',
  'United Arab Emirates': 'V.A. Emirate',
  'Venezuela': 'Venezuela',
  'Vietnam': 'Vietnam',
  'Cyprus': 'Zypern',
  'World Championship': 'WM 2026, Herren',
  'World Championship, Men': 'WM 2026, Herren',
  'WM 2026': 'WM 2026, Herren',
  'Champions League': 'Champions League',
  'International': 'International',
  'International Clubs': 'International'
};

// Fixed display order for legacy usage (fallback)
export const COUNTRY_PRIORITY = SPORT_PRIORITIES['Fußball'] || [
  'Deutschland',
  'Spanien',
  'Italien',
  'England',
  'Niederlande',
  'Schottland',
  'Portugal',
  'Norwegen',
];

/**
 * Stable sort comparator for country names.
 * Priority countries appear first (in defined order),
 * remaining countries sorted alphabetically — never by event count.
 */
export function compareCountries(a: string, b: string, sportName?: string): number {
  const priorities = (sportName && SPORT_PRIORITIES[sportName]) || COUNTRY_PRIORITY;
  const ia = priorities.indexOf(a);
  const ib = priorities.indexOf(b);
  if (ia !== -1 && ib !== -1) return ia - ib;
  if (ia !== -1) return -1;
  if (ib !== -1) return 1;
  return a.localeCompare(b);
}
